import useVariation from '@hooks/useVariation';
import cx from '@utils/cx.util';
import React from 'react';

type Props = {
  className?: string;
  noPadding?: boolean;
  children: React.ReactNode;
};

const ProductInfoContainer = ({ children, className = '', noPadding = false }: Props) => {
  const isEnhancedPDPVariant = useVariation('Enhanced PDP');

  return (
    <div
      className={cx(
        'tw-relative tw-mx-auto lg:tw-mr-0',
        {
          'lg:tw-px-9': !noPadding,
          'tw-max-w-[490px]': isEnhancedPDPVariant,
          'tw-max-w-md': !isEnhancedPDPVariant,
        },
        className
      )}>
      {children}
    </div>
  );
};

export default ProductInfoContainer;
